import { FiPlus } from 'react-icons/fi';
type item = {
  name: string;
  id: number | string;
};
type ISingleOptionProps = {
  item: item;
  selected: any;
  handleSelect: (e: number | string) => void;
};
const SingleOption = ({ item, selected, handleSelect }: ISingleOptionProps) => {
  const isSelected = Array.isArray(selected)
    ? selected.includes(item?.name)
    : selected === item?.id;
  return (
    <div
      className={`single_option ${isSelected ? 'selected_option' : ''}`}
      key={item.id}
      onClick={() => handleSelect(item.id)}
    >
      <div className="plus_icon">
        <FiPlus />
      </div>
      <h4>{item.name}</h4>
    </div>
  );
};

export default SingleOption;
